import { usePhieuNhapKhoMutation } from './usePhieuNhapKhoMutation';
import { usePhieuNhapKhoImport } from './usePhieuNhapKhoImport';
import { usePhieuNhapKhoSearchContext } from './search-context';
import { usePhieuNhapKhoTable } from './usePhieuNhapKhoTable';
import type { PhieuNhapKho } from '@/types/schemas';

export const usePhieuNhapKhoPage = () => {
  const { isExporting, isImportDialogOpen, openImportDialog, closeImportDialog, transactionOptions } =
    usePhieuNhapKhoSearchContext();
  const tableState = usePhieuNhapKhoTable();
  const importState = usePhieuNhapKhoImport({
    closeImportDialog,
    refreshData: tableState.crud.refreshData,
    transactionOptions
  });
  const mutationState = usePhieuNhapKhoMutation({
    detail: tableState.crud.detail,
    formMode: tableState.form.formMode,
    selectedObj: tableState.selection.selectedObj,
    shouldEditWithUpdatedData: tableState.editWithUpdatedDialog.open,
    editPhieuNhapKhoUuid: tableState.editWithUpdatedDialog.uuid,
    addItem: tableState.crud.addItem,
    updateItem: tableState.crud.updateItem,
    deleteItem: tableState.crud.deleteItem,
    handleCloseForm: tableState.form.handleCloseForm,
    handleCloseDelete: tableState.form.handleCloseDelete,
    clearSelection: tableState.selection.clearSelection,
    refreshData: tableState.crud.refreshData,
    handleCloseEditWithUpdatedData: tableState.editWithUpdatedDialog.onClose
  });

  return {
    searchDialog: tableState.searchDialog,
    importDialog: {
      open: isImportDialogOpen,
      isImporting: importState.isImporting,
      openDialog: openImportDialog,
      closeDialog: closeImportDialog,
      onSubmit: importState.handleImportFromExcel
    },
    importErrorDialog: importState.importErrorDialog,
    formDialog: {
      open: tableState.dialogs.showForm,
      formMode: tableState.form.formMode,
      isCopyMode: tableState.dialogs.isCopyMode,
      detail: tableState.crud.detail,
      onClose: tableState.form.handleCloseForm,
      onSubmit: mutationState.handleSubmit,
      onAdd: tableState.form.handleAddClick,
      onEdit: tableState.form.handleEditClick,
      onDelete: tableState.form.handleDeleteClick,
      onCopy: tableState.form.handleCopyClick
    },
    multipleFormDialog: tableState.multipleFormDialog,
    editWithUpdatedDialog: {
      open: tableState.editWithUpdatedDialog.open,
      detail: tableState.editWithUpdatedDialog.detail,
      isLoading: tableState.editWithUpdatedDialog.isLoading,
      onClose: tableState.editWithUpdatedDialog.onClose,
      onSubmit: mutationState.handleSubmit
    },
    deleteDialog: {
      open: tableState.dialogs.showDelete,
      onClose: tableState.form.handleCloseDelete,
      onConfirm: mutationState.handleDelete
    },
    bulkDeleteDialog: {
      open: tableState.dialogs.showBulkDelete,
      onClose: tableState.form.handleCloseBulkDelete,
      onDelete: mutationState.handleBulkDelete
    },
    table: tableState.table,
    detailTable: {
      rows: tableState.selection.selectedObj ? (tableState.crud.detail as PhieuNhapKho | null)?.chi_tiet_data || [] : []
    },
    actions: {
      isExporting,
      handleAddClick: tableState.form.handleAddClick,
      handleEditClick: tableState.form.handleEditClick,
      handleDeleteClick: tableState.form.handleDeleteClick,
      handleCopyClick: tableState.form.handleCopyClick,
      handleRowClick: tableState.form.handleRowClick,
      handleRefresh: tableState.table.onRefresh,
      handleSearch: tableState.searchDialog.onOpen
    },
    selection: {
      selectedObj: tableState.selection.selectedObj,
      selectedRowIndex: tableState.selection.selectedRowIndex
    }
  };
};
